export default __webpack_public_path__ + "static/bncff-web-site-3-cf7d5d1201bf9925ba2de397a9214f72.jpg";